import * as React from 'react';
import Textarea from './Textarea';
export type Props = {
  value?: string;
  type?: string;
  name?: string;
  invalid: boolean;
  className?: string;
  focusOnRender: boolean;
  fullWidth: boolean;
  embiggenToRows: number;
  characterCountBreakpoint: number;
};
export default class FancyTextInput extends React.Component<Props> {
  static defaultProps = {
    type: 'text',
    invalid: false,
    focusOnRender: false,
    fullWidth: false,
  };
  render() {
    const { value } = this.props;
    const { characterCountBreakpoint, embiggenToRows, ...remainingProps } =
      this.props;
    const multiline = value && value.split('\n').length > 1;
    const rows =
      (value == null || value.length < characterCountBreakpoint) && !multiline
        ? 1
        : embiggenToRows;
    return <Textarea rows={rows} {...remainingProps} />;
  }
}
